import { PropertyField } from '@src/app/model/property-field';
import { JsonEditorOptions } from 'ang-jsoneditor';

export class TypedFormData<T> {
  propertyField: PropertyField;
  formData: T;
  editorOptions: JsonEditorOptions;

  constructor(
    propertyField: PropertyField,
    formData: T
  ) {
    this.propertyField = propertyField;
    this.formData = formData;

    this.editorOptions = new JsonEditorOptions();
    this.editorOptions.modes = ['tree', 'text', 'view']; // set all allowed modes
    this.editorOptions.mode = 'tree';
    this.editorOptions.mainMenuBar = true;
  }
}
